import { useCsrCmpState } from '@/hooks/common/useCsrCmpState';
import { useParentEl } from "@/hooks/common/useParentEl";
import { __CLASS_FORM_V3__, __CLASS_CSR_CMP__ } from "@/const/ssrClass";

// 获取form v3下对应cmpName组件的state
export const useFormV3FieldState = (el, cmpName) => {
    const currentFormV3El = useParentEl(el, __CLASS_FORM_V3__);
    const feildEl = currentFormV3El?.querySelector(`.${__CLASS_CSR_CMP__}[data-cmp="${cmpName}"]`);
    const { id } = feildEl || {};
    // id 与 stateKey 等价
    return useCsrCmpState({
        stateKey: id,
    })?.state;
}